import { useSelector, useDispatch } from 'react-redux';
import { login, logout, checkAuth, updateProfileStatus } from '../store/authSlice';

export const useAuth = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  return {
    ...auth,
    // Pass all three: token, refreshToken, userId, profileComplete
    login: (token, refreshToken, userId, profileComplete) =>
      dispatch(login({ token, refreshToken, userId, profileComplete })),
    logout: () => dispatch(logout()),
    checkAuth: () => dispatch(checkAuth()),
    updateProfileStatus: (status) => dispatch(updateProfileStatus(status)),
  };
};